import './App.css';
import Index from './components/Index';


function App() {
  return (
    <div className="App">
    
      <Index/>
     {/* <Admin/> */}
    </div>
  );
}

export default App;
